export const NAV_ITEMS = [
    { id: "services", label: "Services" },
    { id: "smallbusiness", label: "Small business" },
    { id: "how", label: "How it works" },
    { id: "about", label: "About" },
    { id: "map", label: "Find us" },
];

export const SERVICES = [
    {
        num: "01",
        title: "Pre-Purchase Vendor Review",
        desc: "Before you sign a contract with a vendor, we independently review the proposal, pricing, and terms — so you know what you're actually agreeing to.",
        items: [
            "Proposal and contract review",
            "Hidden cost and lock-in check",
            "Written findings report with a clear verdict",
        ],
        price: "3 days",
        unit: "based on scope of work",
        cta: "Enquire",
        selectValue: "01 — Pre-Purchase Vendor Review",
    },
    {
        num: "02",
        title: "Requirements Definition & Vendor Advisory",
        desc: "When it isn't clear what you actually need, we define your requirements from scratch, then check vendor contracts against them and advise which option genuinely fits.",
        items: [
            "Stakeholder requirements gathering",
            "Written requirements document",
            "Vendor contract review against requirements",
            "Recommendation with rationale",
        ],
        price: "10 days",
        unit: "based on scope of work",
        cta: "Enquire",
        selectValue: "02 — Requirements Definition & Vendor Advisory",
    },
    {
        num: "03",
        title: "Pre-Go-Live UAT Testing",
        desc: "Before your new system goes live, we plan and run user acceptance testing with your staff, track defects to resolution, and provide a formal sign-off — or a clear UAT fail report if it isn't ready.",
        items: [
            "UAT plan tailored to your system",
            "Staff-led UAT sessions, facilitated by us",
            "Defect tracking through to resolution",
            "Formal go-live sign-off, or a detailed fail report",
        ],
        price: "5–15 days",
        unit: "scoped by project",
        cta: "Get a scope",
        selectValue: "03 — Pre-Go-Live UAT Testing",
    },
    {
        num: "04",
        title: "AI Implementation Readiness Review",
        desc: "Before you implement an AI tool or workflow, we run it against a practical readiness checklist, review data handling and risk, and provide an advisory report so your rollout is informed, not experimental.",
        items: [
            "AI readiness checklist against your use case",
            "Data handling & risk review",
            "Written advisory report with recommendations",
        ],
        price: "2–5 days",
        unit: "based on scope of work",
        cta: "Enquire",
        selectValue: "04 — AI Implementation Readiness Review",
    },
    {
        num: "05",
        title: "Other Technology & Software Advisory",
        desc: "Anything else technology or software-related that doesn't fit neatly above — process reviews, second opinions on an in-flight project, ad hoc BA or QA support. Tell us what you need and we'll scope it.",
        items: [
            "Scope agreed upfront, charged by the day",
            "No minimum engagement",
        ],
        price: "On request",
        unit: "scoped to your needs",
        cta: "Ask us",
        selectValue: "05 — Other / Not sure yet",
    },
];

export const CONTACT_OPTIONS = [
    SERVICES[0].selectValue,
    SERVICES[1].selectValue,
    SERVICES[2].selectValue,
    SERVICES[3].selectValue,
    "Small Business — AI & Automation Package",
    "05 — Other / Not sure yet",
];

export const MARQUEE_ITEMS = [
    "Hidden cost & lock-in checks",
    "Written findings, clear verdicts",
    "Formal go-live sign-off",
    "Reach us for an initial analysis",
    "Day-rate charges, based on each professional's rate",
    "Independent — we don't sell software",
];
